var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "confirm" }, [
    _c("div", { staticClass: "confirm-box" }, [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v("\n        " + _vm._s(_vm.option.title) + "\n      ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "words" }, [
          _vm._v("\n        " + _vm._s(_vm.option.words) + "\n      ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bottom-bar" }, [
        _vm.option.okWord
          ? _c("div", { staticClass: "ok", on: { click: _vm.onOkClick } }, [
              _vm._v("\n        " + _vm._s(_vm.option.okWord) + "\n      ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.option.cancleWord
          ? _c(
              "div",
              { staticClass: "cancle", on: { click: _vm.onCancleClick } },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.option.cancleWord) + "\n      "
                )
              ]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46fb10e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46fb10e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/confirm.vue
// module id = null
// module chunks = 